import i18next from 'lib/i18next';
import ArticleStructuredData from './Article';

export default class {
  constructor({ comparison, shareUrl }) {
    this.comparison = comparison;
    this.shareUrl = shareUrl;
  }

  get description() {
    return i18next.t('comparison.description', {
      vehicle1: this.comparison.vehicle1,
      vehicle2: this.comparison.vehicle2,
    });
  }

  get image() {
    return this.comparison.vehicle1.photo_url;
  }

  toJSON() {
    const data = {
      image: this.image,
      description: this.description,
    };
    const articleData = new ArticleStructuredData(
      this.comparison,
      this.shareUrl
    );

    return { ...articleData.toJSON(), ...data };
  }
}
